import { Component, OnInit } from '@angular/core';
import { PosFloatingActionButtonService } from 'src/app/@core/services/pos-floating-action-button.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.sass']
})
export class ProductsComponent implements OnInit {

  constructor(private floatingService: PosFloatingActionButtonService) {
    floatingService.removeItems();
  }

  ngOnInit(): void {
  }

}
